// Client lib imports
const airbrake = require('client/lib/airbrake')
const businessEvents = require('client/lib/business-events')
const { send: ajax } = require('client/lib/request')
// Common Client v2 imports
const clientV1Bridge = require('client-v2/common/client-v1-bridge')
const { navigate } = require('client-v2/common/state/router/actions')

// Action types

const INTEREST_FOLLOWING_CHANGE = 'INTEREST_FOLLOWING_CHANGE'

// Action enums

const INTEREST_FOLLOWING_CHANGE_PENDING = 'INTEREST_FOLLOWING_CHANGE_PENDING'

// Action creators

function interestFollowingChange(interestKey, isFollowing) {
  return {
    type: INTEREST_FOLLOWING_CHANGE,
    payload: {
      interestKey,
      isFollowing
    }
  }
}

function interestFollowingChangePending(interestKey) {
  return interestFollowingChange(
    interestKey,
    INTEREST_FOLLOWING_CHANGE_PENDING
  )
}

// Action dispatchers

function navigateToInterestProfile(options) {
  return navigateToInterestProfilePosts(options)
}

function navigateToInterestProfileFollowers({ interest, event, pageContext }) {
  return navigate({
    event,
    href: interestProfileFollowersHref(interest),
    pageContext
  })
}

function navigateToInterestProfilePosts({ interest, event, pageContext }) {
  return navigate({
    event,
    href: interestProfilePostsHref(interest),
    pageContext
  })
}

function toggleFollowing({ interest, pageContext }) {
  return async function (dispatch) {
    const toggledFollowing = !interest.isFollowing
    const action = toggledFollowing ? 'follow' : 'unfollow'
    const method = toggledFollowing ? 'post' : 'delete'
    // Set front-end following state to "pending"
    dispatch(interestFollowingChangePending(interest.key))
    try {
      // Update following state on back-end
      await ajax({
        url: `/api/v0.1/interest/${interest.key}/${action}`,
        method,
        data: { 'page_context': pageContext }
      })
    } catch (err) {
      airbrake.notify(err)
      // Revert the front-end following state
      dispatch(interestFollowingChange(interest.key, interest.isFollowing))
      // Inform the user that their action was unsuccessful
      clientV1Bridge.showAlertModal({
        heading: `Interest preference could not be updated.`,
        subheading: `Something went wrong on our end. Please try again.`
      })
      return
    }
    // Update the front-end to reflect the successful action
    dispatch(interestFollowingChange(interest.key, toggledFollowing))
    // Send tracking call
    await businessEvents.trackSegment(`${action}-topic`, {
      text: interest.key
    }, {
      pageContext
    })
  }
}

// URL helpers

function interestProfileHref(interest) {
  return interestProfilePostsHref(interest)
}

function interestProfileFollowersHref(interest) {
  return `/interest/${interest.key}/followers`
}

function interestProfilePostsHref(interest) {
  return `/interest/${interest.key}`
}

// Exports

module.exports = {
  // Types
  INTEREST_FOLLOWING_CHANGE,
  // Enums
  INTEREST_FOLLOWING_CHANGE_PENDING,
  // Creators
  interestFollowingChange,
  interestFollowingChangePending,
  // Dispatchers
  navigateToInterestProfile,
  navigateToInterestProfileFollowers,
  navigateToInterestProfilePosts,
  toggleFollowing,
  // URL helpers
  interestProfileHref,
  interestProfileFollowersHref,
  interestProfilePostsHref
}
